import { ProviderExtension } from "../registry";

export const googleExtension: ProviderExtension = {
  labels: {
    nativeAudienceLabel: "iOS Client IDs",
    nativeAudiencePlaceholder: "12345-ios.apps.googleusercontent.com",
    nativeAudienceHint:
      "Use the iOS OAuth client ID(s) from console.cloud.google.com.",
    webClientIdLabel: "Web Client ID",
    webClientIdPlaceholder: "12345-web.apps.googleusercontent.com",
  },
};
